"use strict";

/**
* Базовый класс реквизита.
* 
* @class WebAccess.components.wrappers.form.requisites._details.BaseRequisite
* @extends WebAccess.components.wrappers.form.requisites.BaseRequisite
* @mixes WebAccess.components.wrappers.form.requisites._details.editModeMixin
* @private
* @since 5.2.0.1300
*/
(function (global) {

  const BaseRequisite = global.BaseRequisite.extend([global._details.editModeMixin], {
    className: 'DetailBaseRequisite'
  });  

  global._details.BaseRequisite = BaseRequisite;
})(window.WA.CMP.wrappers.form.requisites);